import { getToken, implicitRefresh } from 'colleague-auth'

const decodeToken = (token) => {
  if (!token || !token.id_token) return null
  const tokenBody = token.id_token.split('.')[1]
  const base64 = tokenBody.replace('-', '+').replace('_', '/')
  const tokenData = JSON.parse(window.atob(base64))
  return tokenData
}

const isTokenExpiringInLessThanFiveMinutes = (token) => {
  const tokenData = decodeToken(token)
  const fiveMinutes = 300
  const now = Date.now() / 1000
  return !tokenData || tokenData.exp - fiveMinutes < now
}

const hasTokenExpired = () => {
  const token = getToken()
  if (token && decodeToken(token)) {
    const tokenData = decodeToken(token)
    const now = Date.now() / 1000
    return tokenData.exp < now
  }
  return true
}

const checkToken = () => {
  const token = getToken()
  return new Promise((resolve, reject) => {
    if (token) {
      if (isTokenExpiringInLessThanFiveMinutes(token)) {
        implicitRefresh().then(() => {
          const newToken = getToken()
          resolve(newToken)
        })
      }
      resolve(token)
    } else {
      reject()
    }
  })
}

export {
  decodeToken,
  isTokenExpiringInLessThanFiveMinutes,
  hasTokenExpired,
  checkToken
}



// WEBPACK FOOTER //
// ./src/utils/token.js